import { css } from 'lit';

import { disabled, on } from '../../styles';
import baseStyles from '../button/base-button.styles';
import color from '../../utils/get-color-token';
import token from '../../utils/get-token';

function styles() {
	return [
		baseStyles(),
		css`
			:host {
				/*
				 * These custom properties are here because they are meant to be
				 * overriden via toggle-group styles.
				 */
				--m-toggle-base-size: 30px;
				--m-toggle-font-size: ${token('font-size-3')};
				--m-toggle-icon-size: 12px;
				--m-toggle-icon-display: none;
			}

			.toggle {
				--m-button-border-color: transparent;
				--m-button-color: ${color('color-primary-100')};
				--m-button-padding-x: ${token('spacing-2')};
				--m-button-padding-y: 0;

				--m-button-base-size: var(--m-toggle-base-size);
				--m-button-font-size: var(--m-toggle-font-size);
			}

			${disabled(['.toggle'])} {
				--m-button-color: ${color('color-text-disabled')};
			}

			[aria-checked='true'] {
				--m-button-background-color: ${color('color-primary-20')};
			}

			${on.hover('.toggle')} {
				--m-button-background-color: ${color('color-background-tertiary')};
				--m-button-border-color: ${color('color-background-tertiary')};
				--m-button-color: ${color('color-primary-100')};
			}

			.check-icon {
				--m-icon-size: var(--m-toggle-icon-size);
				--m-icon-color: var(--m-button-color);

				display: var(--m-toggle-icon-display);
			}
		`,
	];
}

export default styles;
